import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import application from './plugins/application'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import './assets/main.css'

Vue.config.productionTip = false
Vue.use(application)

new Vue({
  router,
  store,
  vuetify,
  render(h){
    return h('router-view')
  }
}).$mount('#app')
